module.exports = __webpack_public_path__ + "static/media/Arvo-Bold.ab1dabbd.ttf";